import { EventTrack, EventTrackReference } from '@core/objects';

// TODO: complete list of correct events and texts each tiem new event is added
export const ProjectLogbookEventList : EventTrack[] = [
    {id: 'requests.added', title:'Project was created', reference: EventTrackReference.REQUEST},
    {id: 'requests.labels.added', title: 'Tag added', reference: EventTrackReference.REQUEST},
    {id: 'requests.labels.removed', title: 'Tag removed', reference: EventTrackReference.REQUEST},
    {id: 'requests.files.added', title: 'File added', reference: EventTrackReference.REQUEST},
    {id: 'requests.files.removed', title: 'File removed', reference: EventTrackReference.REQUEST},
    {id: 'requests.status.updated', title: 'Project Stage Change', reference: EventTrackReference.REQUEST},
    {id: 'requests.due_date.updated', title: 'Due date has been set', reference: EventTrackReference.REQUEST},
    {id: 'requests.assigned.updated', title: 'Project has been assigned', reference: EventTrackReference.REQUEST},
    {id: 'requests.messages.added', title: 'Message added', reference: EventTrackReference.REQUEST},
    {id: 'requests.messages.removed', title: 'Message removed', reference: EventTrackReference.REQUEST},
    {id: 'requests.versions.added', title: 'Artwork uploaded', reference: EventTrackReference.REQUEST},
    {id: 'requests.information.updated', title: 'General Info Changed', reference: EventTrackReference.REQUEST},
    // versions only but related to the request UPLOADED versions
    {id: 'versions.labels.added', title: 'Tag added to artwork', reference: EventTrackReference.VERSION},
    {id: 'versions.labels.removed', title: 'Tag removed from artwork', reference: EventTrackReference.VERSION},  
    {id: 'versions.status.updated', title: 'Artwork Status Change', reference: EventTrackReference.VERSION},
    {id: 'versions.messages.added', title: 'Message added to artwork', reference: EventTrackReference.VERSION},
    {id: 'versions.messages.removed', title: 'Message removed from artwork', reference: EventTrackReference.VERSION},
    // maybe use this instead the share one
    // {id: 'versions.approvals.added', key: 'versions.approvals.added',title: 'Feedback requested'},
    {id: 'versions.approvals.updated', title: 'Artwork Approved/Rejected', reference: EventTrackReference.VERSION},
    {id: 'versions.feedbacks.status.updated', title: 'Artwork feedback updated', reference: EventTrackReference.VERSION},
    
    // feedbacks
    {id: 'share.feedbacks.entries.added', title: 'Feedback requested', reference: EventTrackReference.VERSION},
    // send files
    {id: 'share.transfers.entries.added', title: 'Files sent', reference: EventTrackReference.MULTIPLE},
    // upload-version
    {id: 'share.upload-version.entries.added', title: 'Feedback requested', reference: EventTrackReference.VERSION},
    {id: 'versions.version-upload.status.updated', title: 'Artwork feedback updated', reference: EventTrackReference.VERSION},
    // project custom-forms saved
    {id: 'custom_forms.requests.submission.added', title: 'Form value updated', reference: EventTrackReference.REQUEST}
    
];

// Create a Set to store unique titles
const uniqueTitlesSet = new Set<string>();

// Iterate over the logbookEvents array to get unique titles
export const LogbookEventFilterTitlesList: { id: string, title: string }[] = ProjectLogbookEventList.reduce((uniqueTitles, event) => {
    if (!uniqueTitlesSet.has(event.title)) {
        // Add the title to the Set if it's not already present
        uniqueTitlesSet.add(event.title);
        // Add the title to the uniqueTitles array
        uniqueTitles.push({ id: event.title, title: event.title });
    }
    return uniqueTitles;
}, []);

// console.log(uniqueTitlesArray);